import React from "react";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as authActions } from "../redux/actions/authActions";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import LockIcon from "@material-ui/icons/Lock";
import * as authHelpers from "./authHelpers";
import * as routeHelpers from "./routeHelpers";
import "./auth.css";
import Alert from '@material-ui/lab/Alert';

class Login extends React.Component {
  componentDidMount() {
    let user = authHelpers.getAuthUser();
    if (user) {
      if (user.consent) {
        this.props.history.push(routeHelpers.buildRoute("")); //navigate to EntitiesDashboard component
      } else {
        this.props.history.push(routeHelpers.buildRoute("/acceptance-of-terms"));
      }
    }

    const params = new URLSearchParams(this.props.location.search);
    let unlockCode = params.get('c');
    if (unlockCode) {
      const nextLocation = authHelpers.buildRouteWithAuthParams('/login/guest-verification', params);
      this.props.history.push(nextLocation);
    }

  }

  handleClick = (provider) => {
    if (provider) {
      const params = new URLSearchParams(this.props.location.search);
      let ecrId = params.get('ecrId') ?? '';
      let unlockCode = params.get('c'); //TODO - different flow if unlock code is null
      this.props
        .loginWithProvider(provider, ecrId, unlockCode)
        .then((redirect) => {
          if (redirect) {
            window.location = redirect;
          }
        });
    }
  };

  handleLoginAsGuestClick = () => {
    const params = new URLSearchParams(this.props.location.search);
    const nextLocation = authHelpers.buildRouteWithAuthParams('/login/guest-verification', params);
    this.props.history.push(nextLocation);
  };

  render() {
    return (
      <Container maxWidth="sm">
        <>
          {this.props.isLoading ? (
            <>
              <div className="login-loader-message">Loading providers...</div>
              <LinearProgress />
            </>
          ) : (
                        <>
                            <Alert severity="info">
                                You are currently not logged in.  To access the portal, click on the link we've sent to your email.  If you encounter any issues or have not received the email, don't hesitate to reach out to us for assistance.
                </Alert>
              <Typography
                component="h1"
                variant="subtitle1"
                className="login-title"
              >
                {/*<LockIcon*/}
                {/*  style={{ verticalAlign: "text-bottom", marginRight: 5 }}*/}
                {/*/>*/}
                                {/*Login*/}
              </Typography>
              <Divider />

              {this.props.providers.map((provider) => (
                <span key={provider.Code}>
                  <Button
                    style={{ marginTop: 15 }}
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.handleClick.bind(this, provider.Code)}
                  >
                    {provider.Name}
                  </Button>
                </span>
              ))}

              {new URLSearchParams(this.props.location.search).get('c')
                ? <span key="LoginAsGuest">
                  <Button
                    style={{ marginTop: 15 }}
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.handleLoginAsGuestClick.bind(this)}
                  >
                    Login as Guest
                  </Button>
                </span>
                : null}

            </>
          )}
        </>
      </Container>
    );
  }
}

export default connect(
  (state) => state.authentication,
  (dispatch) => bindActionCreators(authActions, dispatch)
)(Login);
